import { BiUpArrowAlt } from "react-icons/bi";
import { MdOutlineOpenInNew } from "react-icons/md";
import { Link } from "react-router-dom";
import { useState } from "react";
import Modal from "../../../components/lib/modal";
import NewUserForm from "./forms/newUserForm";
import UpdatePasswordForm from "./forms/updatePasswordForm";
import CustomButton from "../../../components/lib/customButton";
import UserService from "../../../rest/userService";
import { toast } from "react-toastify";

const UsersTab = ({ users, setUsers }) => {
    const isScreenLarge = window.innerWidth >= 768;
    const [sort, setSort] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false);

    const [passwordUser, setPasswordUser] = useState(null);
    const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] = useState(false);

    const [userToDelete, setUserToDelete] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const handleSortChange = (field) => {
        setSort(field);
        const sorted = [...users].sort((a, b) => {
            if (!a[field]) return 1;
            if (!b[field]) return -1;
            if (typeof a[field] === "string") return a[field].localeCompare(b[field]);
            return a[field] - b[field];
        });
        setUsers(sorted);
    };

    const handleEditUser = (user) => {
        setEditingUser(user);
        setIsNewUserModalOpen(true);
    };

    const handleUpdatePassword = (user) => {
        setPasswordUser(user);
        setIsUpdatePasswordModalOpen(true);
    };

    const handleDeleteUser = (user) => {
        setUserToDelete(user);
        setIsDeleteModalOpen(true);
    };

    const confirmDeleteUser = () => {
        if (!userToDelete) return;
        UserService.deleteUser(userToDelete.login)
            .then(() => {
                toast.success("Usuário excluído com sucesso!");
                setUsers(users.filter(u => u.login !== userToDelete.login));
                setIsDeleteModalOpen(false);
                setUserToDelete(null);
            })
            .catch((err) => {
                console.error(err);
                toast.error("Erro ao excluir usuário");
            });
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow flex flex-col gap-4">
            <div className="flex justify-between items-center">
                <h2 className="text-lg font-semibold">Usuários Cadastrados</h2>
                <button
                    className="px-4 py-2 bg-blue-500 text-white rounded-xl mb-4"
                    onClick={() => setIsNewUserModalOpen(true)}
                >
                    Novo Usuário
                </button>
            </div>

            <div className="overflow-x-auto rounded-2xl">
                <table className="table-fixed w-full border-collapse divide-y divide-custom_blue shadow-md">
                    <thead>
                        <tr className="bg-custom_blue text-white sm:text-xs lg:text-sm h-12 font-montserrat">
                            <th className="w-1/6 text-left px-2 hidden md:table-cell">Login</th>
                            <th className="w-1/5 text-left px-2">
                                <button onClick={() => handleSortChange("name")}>
                                    {sort === "name" ? (
                                        <p className="flex items-center">
                                            Nome <BiUpArrowAlt className="mx-2 scale-150" />
                                        </p>
                                    ) : "Nome"}
                                </button>
                            </th>
                            <th className="w-1/4 text-left px-2">
                                <button onClick={() => handleSortChange("email")}>
                                    {sort === "email" ? (
                                        <p className="flex items-center">
                                            Email <BiUpArrowAlt className="mx-2 scale-150" />
                                        </p>
                                    ) : "Email"}
                                </button>
                            </th>
                            <th className="w-1/6 text-left px-2">
                                <button onClick={() => handleSortChange("role")}>
                                    {sort === "role" ? (
                                        <p className="flex items-center">
                                            Cargo <BiUpArrowAlt className="mx-2 scale-150" />
                                        </p>
                                    ) : "Cargo"}
                                </button>
                            </th>
                            <th className="w-1/6 text-center px-2">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr
                                key={index}
                                className="text-sm sm:text-xs lg:text-sm font-montserrat font-medium border-2 text-custom_gray-font leading-8 hover:bg-gray-50"
                            >
                                <td className="hidden md:table-cell px-2 truncate">{user.login}</td>
                                <td className="px-2 truncate">{user.name}</td>
                                <td className="px-2 truncate">{user.email ?? "-"}</td>
                                <td className="px-2">{user.role ?? "-"}</td>
                                <td className="px-2 flex flex-wrap justify-center gap-1 py-4">
                                    {isScreenLarge ? (
                                        <>
                                            <CustomButton
                                                text={"Editar"}
                                                buttonType={"confirm"}
                                                type={"button"}
                                                showIcon={false}
                                                onClick={() => handleEditUser(user)}
                                            />
                                            <CustomButton
                                                text={"Redefinir Senha"}
                                                buttonType={"confirmLater"}
                                                type={"button"}
                                                showIcon={false}
                                                onClick={() => handleUpdatePassword(user)}
                                            />
                                            <CustomButton
                                                text={"Excluir"}
                                                buttonType={"delete"}
                                                type={"button"}
                                                showIcon={false}
                                                onClick={() => handleDeleteUser(user)}
                                            />
                                        </>
                                    ) : (
                                        <Link to={`/usuarios/detalhes/${user.login}`} target="_self">
                                            <MdOutlineOpenInNew className="cursor-pointer text-custom_gray_font scale-150" />
                                        </Link>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Modal de novo usuário */}
            <Modal
                isOpen={isNewUserModalOpen}
                setIsOpen={setIsNewUserModalOpen}
                title={editingUser ? "Editar Usuário" : "Novo Usuário"}
                onSave={() =>
                    document.getElementById("newUserForm")?.dispatchEvent(
                        new Event("submit", { cancelable: true, bubbles: true })
                    )
                }
            >
                <NewUserForm
                    userToEdit={editingUser}
                    closeModal={() => {
                        setIsNewUserModalOpen(false);
                        setEditingUser(null);
                    }}
                />
            </Modal>

            {/* Modal de atualização de senha */}
            {isUpdatePasswordModalOpen && passwordUser && (
                <Modal
                    isOpen={isUpdatePasswordModalOpen}
                    setIsOpen={setIsUpdatePasswordModalOpen}
                    title={`Redefinir Senha: ${passwordUser.name}`}
                    onSave={() =>
                        document.getElementById("updatePasswordForm")?.dispatchEvent(
                            new Event("submit", { cancelable: true, bubbles: true })
                        )
                    }
                >
                    <UpdatePasswordForm
                        userLogin={passwordUser.login}
                        clientCode={passwordUser.client_code}
                        closeModal={() => setIsUpdatePasswordModalOpen(false)}
                    />
                </Modal>
            )}

            {/* Modal de confirmação de exclusão */}
            {isDeleteModalOpen && userToDelete && (
                <Modal
                    isOpen={isDeleteModalOpen}
                    setIsOpen={setIsDeleteModalOpen}
                    title="Confirmação de Exclusão"
                    hideFooter
                >
                    <p>Tem certeza que deseja excluir o usuário <b>{userToDelete.name}</b>?</p>
                    <div className="mt-4 flex justify-end gap-2">
                        <button
                            className="px-4 py-2 bg-gray-300 rounded-xl"
                            onClick={() => setIsDeleteModalOpen(false)}
                        >
                            Cancelar
                        </button>
                        <button
                            className="px-4 py-2 bg-red-500 text-white rounded-xl"
                            onClick={confirmDeleteUser}
                        >
                            Sim, excluir
                        </button>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default UsersTab;
